import {Vue} from 'ui.vue';

let interval = false;

import "./BXmakerAuthuserphoneTimeout.styl";

/**
 * @emits onComplete {} (local)  - таймер закончился
 */
Vue.component('BXmakerAuthuserphoneTimeout', {
    props: {
        timeout: {
            type: [Number, Boolean],
            default: 30
        },
    },
    data() {
        return {
            sec: this.timeout ?? 0,
        }
    },
    destroy() {
        this.clear();
    },
    created() {
        if (this.sec > 0) {
            this._interval = setInterval(() => {
                this.sec--;
                if (this.sec <= 0) {
                    this.clear();
                    this.$emit('onComplete')
                }
            }, 1000);
        } else {
            this.clear();
            this.$emit('onComplete')
        }
    },
    methods: {
        // таймер закончился
        clear() {
            if (this._interval) {
                clearInterval(this._interval);
            }
        }
    },
    computed: {
        time() {
            return ("0" + Math.floor(this.sec / 60)).slice(-2) + ':' + ("0" + (this.sec % 60)).slice(-2);
        }
    },
    template: `
        <div class="bxmaker-authuserphone-timeout"  >   
            <slot name="before" />           
            <span class="bxmaker-authuserphone-timeout__time">{{time}}</span> 
            <slot name="after" />                     
        </div>
    `
});